module.exports = __webpack_public_path__ + "static/media/galerija_2014 (20).fb639881.jpg";